/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 47,
    height: 60,
    viewBox: '0 0 47 60',
    data: '<path d="M28.98 15.12C28.98 16.7161 30.2839 18.02 31.88 18.02H46.5V54C46.5 57.0039 44.0039 59.5 41 59.5H6C2.99614 59.5 0.5 57.0039 0.5 54V6C0.5 2.99614 2.99614 0.5 6 0.5H28.98V15.12Z" /><path d="M30.0195 1.20711L45.7924 16.98H31.7378C30.8394 16.9098 30.0897 16.1602 30.0195 15.2617V1.20711Z" /></svg>'
  }
})
